module.exports = __webpack_public_path__ + "8356f9d34f06f6f8c56ec7f3c9d2807c.png";